import eConfig from "../configures";
import moment from "moment";
import {dropboxConfig, dropboxConfig2} from "../configures/dropbox-config";
import Base64 from "./Base64";

const refreshAccessToken = async () => {
    try {
        const response = await fetch('https://api.dropboxapi.com/oauth2/token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                grant_type: 'refresh_token',
                refresh_token: dropboxConfig2.DROPBOX_REFRESH_TOKEN, // Replace with your refresh token
                client_id: dropboxConfig2.DROPBOX_CLIENTID,         // Replace with your app key
                client_secret: dropboxConfig2.DROPBOX_SECRET,       // Replace with your app secret
            }).toString(),
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Error refreshing access token:', errorData);
            throw new Error(errorData.error_description || 'Unable to refresh access token');
        }

        const data = await response.json();
        console.log('New Access Token:', data.access_token);
        return data.access_token;
    } catch (error) {
        console.error('Error refreshing access token:', error.message);
        throw new Error('Unable to refresh access token');
    }
};

export const UploadToDropBoxBase64WithBusket=async (base64String,busket,org,client,item,ref,fileName,feedback) =>{
    let imageData = _base64ToArrayBuffer(base64String);
    let key = await refreshAccessToken(); // Ensure this is working correctly dropboxConfig.DROPBOX_TOKEN;
    let date = moment().format("YYYY-MM-DD");
    console.log("RRRRFilename > ",fileName)
    let arrExt = fileName.split(".");
    let ext = arrExt[(arrExt.length-1)]
    let contentType = "application/octet-stream";
    if(ext.toLocaleLowerCase()==="pdf"){
        //contentType = "application/pdf";
    }
    let dropboxApiArg = {
        "path":`/applications/pmis/${busket}/${org}/${org}--${client}--${item}--${ref}--${date}.${ext}`,
        "mode": "add",
        "autorename": true,
        "mute": false
    }
    console.log("UUUUUUUUUU>> ",fileName, " > ",ext," > ",dropboxApiArg)
    let headers={
        "Authorization":"Bearer "+key,
        "Content-Type": contentType,
        "Dropbox-API-Arg":JSON.stringify(dropboxApiArg)
    }
    return fetch("https://content.dropboxapi.com/2/files/upload", {
        method: "POST",
        headers:headers,
        body: imageData
    })
        .then(response =>response.json())
        .then(response => {
            const endpoint ="/files/download/"+response.rev;
            let server = dropboxConfig.server+"/"+dropboxConfig.serverBackend;
            let url = server + "" +endpoint
            feedback(url);
            return url
        })
        .catch(error => {
            console.log("upload error", error);
            alert("Upload failed!");
        });
}

function _base64ToArrayBuffer(base64) {
    base64 = base64.split(';base64,')[1];
    let binary_string = Base64.atob(base64),
        len = binary_string.length,
        bytes = new Uint8Array(len),
        i;
    for (i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}
